/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Error_Missing_ColumnsInputs */

const en_ledger_error_missing_columns = /** @type {(inputs: Ledger_Error_Missing_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The query result is missing required columns`)
};

const nl_ledger_error_missing_columns = /** @type {(inputs: Ledger_Error_Missing_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In het queryresultaat ontbreken verplichte kolommen`)
};

/**
* | output |
* | --- |
* | "The query result is missing required columns" |
*
* @param {Ledger_Error_Missing_ColumnsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_error_missing_columns = /** @type {((inputs?: Ledger_Error_Missing_ColumnsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Error_Missing_ColumnsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_error_missing_columns(inputs)
	return en_ledger_error_missing_columns(inputs)
});